var site = site || {};

(function ($) {
  Drupal.behaviors.aerinFFQuestionFormatterV1 = {
    counter: 1,
    attach: function (context) {
      var self = this;
      var $modules = $('.js-aerin-ff-question-formatter', context);
      var $parent = $modules.closest('.js-aerin-fragrance-finder-formatter');
      var $answerItem = $modules.find(
        '.js-aerin-ff-question-formatter-options .content-block-tout'
      );
      var selectedAnswer;
      var parentData;

      self.initSetup($modules, $answerItem);
      $($answerItem)
        .once()
        .on('click', function () {
          selectedAnswer = $(this).data('answer-value');
          parentData = $parent.attr('data-answer');
          if (parentData === 'undefined' || parentData === null || parentData === '') {
            $parent.attr('data-answer', selectedAnswer);
          } else {
            selectedAnswer = parentData + ',' + selectedAnswer;
            $parent.attr('data-answer', selectedAnswer);
          }
          $modules.eq(self.counter - 1).addClass('aerin-ff-question-formatter__options--hide');
          if ($(this).closest('.js-aerin-ff-question-formatter--last').length > 0) {
            self.lastQuestion($parent, $modules);
          } else {
            $modules.eq(self.counter - 1).addClass('aerin-ff-question-formatter__options--hide');
            $modules.eq(self.counter).removeClass('aerin-ff-question-formatter__options--hide');
          }
          self.counter++;
          self.fireAnalytic('Answer', selectedAnswer);
          self.questionChange(selectedAnswer);
        });
    },
    initSetup: function ($modules, $answerItem) {
      var $module;
      var moduleQuestion;

      $modules.each(function (index) {
        $module = $(this);
        if (index > 0) {
          $module.addClass('aerin-ff-question-formatter__options--hide');
        }
        if (index === $modules.length - 1) {
          $module.addClass('js-aerin-ff-question-formatter--last');
        }
        moduleQuestion = $(this).data('answer-list').split(',');
        $module.find($answerItem).each(function (ansIndex) {
          if (ansIndex === moduleQuestion.length) {
            return;
          }
          $(this).attr('data-answer-value', moduleQuestion[ansIndex]);
        });
      });
    },
    lastQuestion: function ($parent, $modules) {
      var $results;
      var $resultsContainer;
      var $contentHeader = $parent.find('.js-aerin-fragrance-finder-formatter-content');
      var selectedResultsList = $parent.attr('data-answer').split(',');
      var $closestAnswer;
      var scoreHighest = 0;
      var resultList;
      var score = 0;

      $modules.eq(self.counter - 1).addClass('aerin-ff-question-formatter__options--hide');
      $results = $parent.find('.js-aerin-fragrance-finder-result');
      $resultsContainer = $parent.find('.js-aerin-fragrance-finder-result-formatter');
      $results.each(function (parentIndex) {
        if ($(this).data('result-list')) {
          resultList = $(this).data('result-list').split(',');
          $.each(resultList, function (resultIndex, resultValue) {
            if (resultValue === selectedResultsList[resultIndex]) {
              score++;
            }
          });

          if (score > scoreHighest) {
            $closestAnswer = $($results[parentIndex]);
            scoreHighest = score;
          }
          score = 0;
        }
      });
      $contentHeader.addClass('inactive');
      $resultsContainer.addClass('aerin-fragrance-finder-result-formatter--show');
      if ($closestAnswer.length > 0) {
        $closestAnswer.addClass('aerin-fragrance-finder-result--show');
      }
    },
    questionChange: function (selectedAnswer) {
      var self = this;

      $.event.trigger({
        type: 'af_question:question_change',
        payload: {
          counter: self.counter,
          answer: selectedAnswer
        }
      });
    },
    fireAnalytic: function (eventAction, eventLabel) {
      if (site && site.track) {
        site.track.evtLink({
          event_name: 'elAerinFragranceFinder',
          event_category: 'Aerin Fragrance Finder',
          event_action: eventAction,
          event_label: eventLabel
        });
      }
    }
  };
})(jQuery);
